<template>
    <div class="">
        <div class="live-title">Live</div>
        <div class="bck-txt">
            <marquee behavior="" direction="">{{event.title}}</marquee>
        </div>
        <component :is="selectedComponent" v-bind="event"></component>
        <div class="vt">{{event.live_event_text}}</div>
<!--        <div class="pwd-by"><span class="text mr-1">Powered by</span><span class="by mr-1">Zesta</span><span class="count">(4.5k followers)</span></div>-->
    </div>
</template>
<script>
import vimeo from '../Moderator/vimeo'
import youtube from '../Moderator/youtube'
import otherStream from '../Moderator/otherStream'
export default {
    props :['event'],
    computed: {
        selectedComponent() {
            const type = Number(this.event?.is_non_vimeo_event);

            if (type === 0) return 'vimeo';
            if (type === 1) return 'youtube';
            if (type === 3) return 'aws';
            return 'otherStream';
        }
    },

    components : {
        vimeo,
        youtube,
        otherStream
    }
}
</script>
<style scoped>
    .live-title {
    color: #FF0000;
    font-size: 22px;
  }
  .bck-txt {
    text-transform: uppercase;
    background: #3699FF;
    color: #fff;
    padding: 10px;
    font-weight: 500;
    border-radius: 4px;
  }
  .vt {
    font-size: 16px;
    font-weight: 600;
  }
</style>
